import React, { createContext, useContext, useState, useEffect } from "react";
import { UserAuth } from "../context/AuthContext";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";

const PurchasedPricesContext = createContext();

export const usePurchasedPrices = () => {
  return useContext(PurchasedPricesContext);
};

export const PurchasedPricesProvider = ({ children }) => {
  const { user } = UserAuth();
  const [purchasedPrices, setPurchasedPrices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPurchasedPrices = async () => {
      if (user && user.uid) {
        try {
          const db = getFirestore();
          const paymentsRef = collection(db, "users", user.uid, "payments");
          const paymentsSnap = await getDocs(paymentsRef);
          //console.log(
          //  "Total documents in payments collection:",
          //  paymentsSnap.size
          //);

          const productIds = paymentsSnap.docs
            .filter((doc) => doc.data().status === "succeeded")
            .flatMap((doc) => {
              const data = doc.data();
              //console.log("Processing succeeded payment:", data);

              if (data.items && Array.isArray(data.items)) {
                //console.log("Items is an array:", data.items);
                return data.items
                  .map((item) => item.price?.product)
                  .filter(Boolean);
              }

              //console.log("No items found in payment");
              return [];
            });

          //console.log("Initial product IDs:", productIds);

          const uniqueProductIds = [...new Set(productIds)];
          const allProductIds = [];

          for (const productId of uniqueProductIds) {
            const productRef = doc(db, "products", productId);
            const productSnap = await getDoc(productRef);

            if (productSnap.exists()) {
              const productData = productSnap.data();
              allProductIds.push(productId);

              if (productData.metadata && productData.metadata.items) {
                //console.log(
                //  `Additional items for product ${productId}:`,
                //  productData.metadata.items
                //);
                const additionalItems = productData.metadata.items
                  .split(",")
                  .map((item) => item.trim());
                allProductIds.push(...additionalItems);
              }
            } else {
              //console.log(`Product ${productId} not found`);
            }
          }

          const finalUniqueProductIds = [...new Set(allProductIds)];
          //console.log("Final unique product IDs:", finalUniqueProductIds);
          setPurchasedPrices(finalUniqueProductIds);
        } catch (error) {
          //console.error("Error fetching purchased prices:", error);
        }
      } else {
        //console.warn("User or user.uid is undefined");
        setPurchasedPrices([]);
      }
      setLoading(false);
    };

    fetchPurchasedPrices();
  }, [user]);

  return (
    <PurchasedPricesContext.Provider value={{ purchasedPrices, loading }}>
      {children}
    </PurchasedPricesContext.Provider>
  );
};
